import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Tyre Replacement Reason'}
      url={'scrap-reason'}
      queryKey="scrap-reason"
      title={'Scrap Reason'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
